import { DEFAULT_WORD_CLOUD_APPEARANCE } from "./wordCloudAppearance";

export const NETWORKGRAPH = "networkgraph";
export const MOREGRAPH = "more";

export const STOPWORD_GROUPS = [
    { value: "prepositions", label: "Preposiciones", words: "a, al, ante, bajo, con, contra, de, del, desde, en, entre, hasta, para, por, según, sin, sobre" },
    { value: "articles", label: "Artículos", words: "el, la, las, lo, los, un, una, unos" },
    { value: "pronouns", label: "Pronombres", words: "algo, cual, ella, ellas, ellos, eso, esto, le, les, me, nada, nos, nosotros, os, quien, se, te, ti, tú, uno, usted, ustedes, yo" },
    { value: "determiners", label: "Determinantes", words: "algunas, algunos, aquel, aquella, aquellas, aquellos, cada, esa, esas, ese, esos, esta, estas, este, estos, mi, mis, nuestra, nuestro, otra, otro, su, sus, todo, tus" },
    { value: "conjunctions", label: "Conjunciones", words: "como, ni, o, pero, porque, que, si, y" },
    { value: "adverbs", label: "Adverbios", words: "antes, aquí, así, aún, bien, casi, cuando, donde, más, mucho, muy, no, poco, también, ya" },
    { value: "verbs", label: "Verbos frecuentes", words: "era, eres, es, estaba, estamos, están, estar, fue, ha, había, han, hay, ser, son, tengo, tiene" },
    { value: "numerals", label: "Numerales", words: "uno, dos, tres, cuatro, cinco, seis, siete, ocho, nueve, diez", examplesOnly: true },
];

export const getWordCloudStopwordGroups = (configuration = {}, legacyDefault = true) =>
    configuration.stopwordGroups ??
    ((configuration.useSpanishStopwords ?? legacyDefault)
        ? STOPWORD_GROUPS.map((group) => group.value)
        : []);

export const VISIBILITY = {
    public: "PUB",
    private: "PRIV",
    community: "COMM",
    hide: "HIDE",
};

export const VISIBILITY_MAP = {
    [VISIBILITY.community]: "Comunidad",
    [VISIBILITY.hide]: "Archivado",
    [VISIBILITY.public]: "Establecimiento",
    [VISIBILITY.private]: "Privado",
};

export const QUALIFICATION = {
    disapproved: "DISA",
    approved: "APPR",
    reDelivery: "REDE",
};

export const QUALIFICATION_LABEL = {
    DISA: "Desaprobado",
    APPR: "Aprobado",
    REDE: "Re entrega",
};

export const MAP_COLUMNS = {
    value: "Eje x (categoría)",
    group_by: "Eje y (subcategoría)",
    valuePie: "Categorizar por",
    datasetColumns: "Columnas Dataset",
    source: "Origen",
    target: "Destino",
    lat: "Latitud",
    lon: "Longitud",
    name: "Nombre",
};

export const MAP_GRAPHS = {
    dataTable: "Tabla de datos",
    column: "Columnas agrupadas",
    line: "Líneas agrupadas",
    pie: "Torta",
    bubble: "Burbujas",
    dispersion: "Dispersión",
    map: "Mapa",
    social_user_comments: "Grafo de interacción entre usuarios",
    social_word_frequency: "Grafo de coocurrencias de palabras",
    static_network: "Grafo",
    word_cloud: "Nube de palabras",
};

export const ROLE_MAP = {
    admin: "Administrador",
    teacher: "Profesor",
    student: "Estudiante",
    superadmin: "Superadmin",
};

export const USER = "USER";
export const COURSE = "COUR";
export const QUESTION = "QUES";

export const PENDING_NOTIFICATION_MAP = {
    superadmin: [USER],
    admin: [COURSE, USER],
    teacher: [COURSE, QUESTION],
    student: [QUESTION],
};

export const DEFAULT_DATA_GRAPHER = {
    dataTable: {
        selected: false,
        columns: { value: [] },
        export: { image: null, offsetHeight: null, offsetWidth: null },
        comment: "",
        filterInclude: [],
        filterExclude: [],
        limitDrag: 1,
        dataSource: "static",
    },
    column: {
        selected: false,
        columns: { value: [], group_by: [] },
        export: { image: null, offsetHeight: null, offsetWidth: null },
        comment: "",
        filterInclude: [],
        filterExclude: [],
        limitDrag: 1,
        dataSource: "static",
    },
    line: {
        selected: false,
        columns: { value: [], group_by: [] },
        export: { image: null, offsetHeight: null, offsetWidth: null },
        comment: "",
        filterInclude: [],
        filterExclude: [],
        limitDrag: 1,
        dataSource: "static",
    },
    pie: {
        selected: false,
        columns: { valuePie: [] },
        export: { image: null, offsetHeight: null, offsetWidth: null },
        comment: "",
        filterInclude: [],
        filterExclude: [],
        limitDrag: 1,
        dataSource: "static",
    },
    bubble: {
        selected: false,
        columns: { value: [], group_by: [] },
        export: { image: null, offsetHeight: null, offsetWidth: null },
        comment: "",
        filterInclude: [],
        filterExclude: [],
        limitDrag: 1,
        dataSource: "static",
    },
    dispersion: {
        selected: false,
        columns: { value: [] },
        export: { image: null, offsetHeight: null, offsetWidth: null },
        comment: "",
        filterInclude: [],
        filterExclude: [],
        limitDrag: 1,
        dataSource: "static",
    },
    social_word_frequency: {
        selected: false,
        export: { image: null, offsetHeight: null, offsetWidth: null },
        comment: "",
        filterInclude: [],
        filterExclude: [],
        dataSource: "dynamic",
        nodesId: [],
    },
    social_user_comments: {
        selected: false,
        export: { image: null, offsetHeight: null, offsetWidth: null },
        comment: "",
        filterInclude: [],
        filterExclude: [],
        dataSource: "dynamic",
        nodesId: [],
    },
    map: {
        selected: false,
        columns: { lat: [], lon: [], name: [] },
        export: { image: null, offsetHeight: null, offsetWidth: null },
        comment: "",
        filterInclude: [],
        filterExclude: [],
        limitDrag: 1,
        dataSource: "static",
    },
    static_network: {
        selected: false,
        columns: { source: [], target: [] },
        export: { image: null, offsetHeight: null, offsetWidth: null },
        comment: "",
        filterInclude: [],
        filterExclude: [],
        limitDrag: 1,
        dataSource: "static",
        metric: "normal",
    },
    word_cloud: {
        ...DEFAULT_WORD_CLOUD_APPEARANCE,
        selected: false,
        columns: { value: [] },
        export: { image: null, offsetHeight: null, offsetWidth: null },
        comment: "",
        filterInclude: [],
        filterExclude: [],
        limitDrag: 2,
        dataSource: "static",
        wordLimit: 100,
        stopwordGroups: STOPWORD_GROUPS.map((group) => group.value),
        customStopwords: [],
    },
};
